<!-- Translated: skip -->
<template>
  <button v-ripple :class="{'filter-list-item': true, disabled: ($store.state.cart.addToOrder && $store.state.cart.addToOrder.number && filter === 'date')}" @click="click">
    <icon :name="computedIcon" v-if="computedIcon" :scale="1" class="icon" />
    <span>{{ computedLabel }}</span>
    <span class="close">
      <icon name="times" :scale="0.8"></icon>
    </span>
  </button>
</template>

<script>
import {
  formatAccomodationsFilterDate,
  titleCase,
} from '@/lib';

export default {
  props: [
    'filter',
    'value',
    'label',
    'icon',
  ],
  methods: {
    click() {
      this.$emit('click');
    },
  },
  computed: {
    computedIcon() {
      if (this.icon) {
        return this.icon;
      }

      switch (this.filter) {
        case 'date':
          return 'calendar-blue';
        default:
          return null;
      }
    },
    computedLabel() {
      if (this.label) {
        return this.label;
      }

      switch (this.filter) {
        case 'date':
          return formatAccomodationsFilterDate(this.value.startDate, this.value.endDate);
        case 'beds':
          return `${this.value}+ bäddar`;
        case 'bedrooms':
          return `${this.value}+ sovrum`;
        case 'sauna':
          return 'Bastu';
        case 'direct_incheck':
          return 'Digital incheckning';
        case 'pets':
          return 'Husdjur tillåtet';
        case 'chargeStation':
          return 'Laddstolpe';
        case 'fireplace':
          return 'Öppen spis';
        case 'dishwasher':
          return 'Diskmaskin';
        case 'dryer_cabinet':
          return 'Torkskåp';
        case 'washing_machine':
          return 'Tvättmaskin';
        case 'cleaning':
          return 'Slutstäd ingår';
        case 'locationId':
          return 'Område valt';
        case 'internet':
          return 'Internet';
        case 'child_friendly':
          return 'Extra barnanpassat';
        default:
          return `${titleCase(this.filter)}: ${this.value}`;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.disabled
  disabled()

.filter-list-item
  button-reset()
  display flex
  align-items center
  background white
  border 1px solid light-blue
  color deep-blue
  border-radius 4px
  text-transform uppercase
  padding 6px 6px 6px 10px
  line-height 1em
  font-weight bold
  font-size 10px
  transition all .2s ease
  &:hover
    border-color alpha(deep-blue, .5)
  &:focus
    outline none
    border-color deep-blue
  &.active
    background-color deep-sea-blue
    border solid 1px light-blue-grey
    color white


.icon
  margin-right 0.8rem
  left 2px
  .close &
    position: absolute;

.close
  circle(14px)
  center-content()
  margin-left space-1
  border 1px solid deep-sea-blue
  position relative

</style>



// WEBPACK FOOTER //
// FilterListItem.vue?9a2d5220